import "./src/fonts/fonts.css"
// eslint-disable-next-line import/prefer-default-export
export { wrapPageElement } from "./wrap-page-element"

